import { render, staticRenderFns } from "./commission-fee.vue?vue&type=template&id=7728ef82"
import script from "./commission-fee.vue?vue&type=script&lang=ts"
export * from "./commission-fee.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports